<div class="p-6">
    <div class="flex items-center justify-between mb-0">
        <h2 class="text-2xl font-semibold text-[#23272e] m-0">Delete this shift?</h2>
        <button mat-icon-button (click)="onCancel()" class="text-gray-500 hover:text-gray-700 -mr-2">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <div class="mb-6 flex flex-col max-w-[355px]">
        <p class="text-base text-gray-700 mb-4">
            <strong>{{ shift?.shift_name }}</strong> will be permanently deleted.
        </p>

        <div *ngIf="isLoadingEmployees" class="flex items-center justify-center py-4">
            <mat-spinner diameter="30"></mat-spinner>
        </div>

        <div *ngIf="!isLoadingEmployees && assignedEmployees.length > 0"
            class="w-full text-left bg-orange-50 border border-orange-200 rounded-lg p-4 mb-2">
            <div class="flex items-start gap-2 text-orange-800 mb-3">
                <mat-icon class="text-orange-500 mt-0.5"
                    style="font-size: 20px; width: 45px; height: 20px;">info</mat-icon>
                <span class="text-sm">The following {{ assignedEmployees.length }} employees are assigned to this shift and will be unassigned.</span>
            </div>

            <div class="max-h-40 overflow-y-auto pr-2 custom-scrollbar">
                <div class="grid grid-cols-1 sm:grid-cols-2 gap-2">
                    <div *ngFor="let emp of assignedEmployees"
                        class="flex items-center gap-2 bg-white border border-gray-100 rounded p-2">
                        <ngx-avatars [name]="emp.name" size="24"></ngx-avatars>
                        <span class="text-sm font-medium text-gray-700 truncate" [title]="emp.name">{{ emp.name
                            }}</span>
                    </div>
                </div>
            </div>
        </div>

        <div *ngIf="!isLoadingEmployees && assignedEmployees.length === 0"
            class="w-full text-left bg-gray-50 border border-gray-200 rounded-lg p-4 mb-2 text-gray-500 text-sm flex items-center gap-2">
            <mat-icon>check_circle_outline</mat-icon> No employees are currently assigned to this shift.
        </div>
    </div>

    <div class="flex items-center justify-end gap-3 mt-6">
        <button mat-stroked-button (click)="onCancel()" [disabled]="isDeleting"
            class="px-6 py-2 rounded-md font-medium text-gray-700 border-gray-300">
            Cancel
        </button>
        <button mat-raised-button color="warn" (click)="onDelete()" [disabled]="isDeleting"
            class="px-6 py-2 rounded-md font-medium">
            Delete shift
        </button>
    </div>
</div>